// removed by extract-text-webpack-plugin
module.exports = {"flexAlign":"_1QCcmMSKn3ROaxTxrIm7Mw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/FlexAlign/style.css
// module id = 271
// module chunks = 42